import ZomentumIcon from "@v2assets/ZomentumIcon.svg?url";
import ZomentumLogo from "@v2assets/ZomentumLogo.svg?url";

import { ZIcon, ZPopover } from "@atoms";
import { EIcons } from "@atoms/ZIcon/interface";
import useBreakpoint from "@/Hooks/useBreakpoint";
import useMobileView from "@/Hooks/useMobileView";
import { Badge, Layout } from "antd";
import React, { Fragment } from "react";
import { IAppHeader } from "./interface";
import "./index.less";
import ZAppSwitcher from "./ZAppSwitcher";

const AppHeader: React.FC<IAppHeader> = ({
	badgeCount = 0,
	shouldShowHeader,
	showNotificationIcon,
	NotificationsComponent,
	handleLogoRoute,
	children,
	extraRenderNotification,
	appSwitcher: {
		appSwitcherEnabled,
		paymentsAppSwitchEnabled,
		growUrl,
		paymentUrl
	},
	isEmbedded = false
}) => {
	const isSmallerScreenSize = useBreakpoint("(max-width: 1280px)");
	const isMobileView = useMobileView();

	return !!shouldShowHeader ? (
		<Layout.Header className="z-app-header border-0 border-b border-solid">
			<div
				className={`header-row overflow-x-hidden grid items-center ${
					isEmbedded
						? "header-row-superops"
						: "header-row-with-beamer"
				} ${!showNotificationIcon ? "header-for-mobile" : ""} ${
					appSwitcherEnabled ? "header-with-app-switcher" : ""
				}`}
			>
				{!isEmbedded && (
					<div className="flex items-center align-center mx-2">
						{appSwitcherEnabled && !!growUrl && paymentUrl && (
							<ZAppSwitcher
								growUrl={growUrl}
								paymentUrl={paymentUrl}
								paymentsAppSwitchEnabled={
									paymentsAppSwitchEnabled
								}
							/>
						)}
						<div
							onClick={handleLogoRoute}
							className={`zomentum-logo border-0 ${
								!isMobileView ? "border-r" : ""
							} border-solid flex justify-center w-max px-4`}
						>
							{isSmallerScreenSize ? (
								<img
									src={ZomentumIcon}
									width={30}
									height={30}
									alt="Zomentum Logo"
								/>
							) : (
								<img
									src={ZomentumLogo}
									width={154}
									height={20}
									alt="Zomentum Logo"
								/>
							)}
						</div>
					</div>
				)}
				<div
					className={`header-children flex justify-between items-center ${
						showNotificationIcon ? "" : "mr-4"
					} ${isEmbedded ? "header-children-superops" : ""}`}
				>
					{children}
				</div>
				{!isEmbedded && showNotificationIcon && (
					<div className="header-actions-container flex items-center justify-end pr-3.5">
						{extraRenderNotification}
						<div className="notification-menu-container">
							<ZPopover
								content={NotificationsComponent}
								trigger="click"
								hideArrow={true}
								removeDefaultPadding={true}
								placement="bottomLeft"
								openClassName="mr-2"
								overlayClassName="w-105"
							>
								<div
									className="notification-menu-trigger relative cursor-pointer"
									title="Notifications"
								>
									<Badge
										className="notification-count"
										count={badgeCount}
									/>
									<ZIcon
										name={EIcons.NOTIFICATION}
										colorVariant={7}
									/>
								</div>
							</ZPopover>
						</div>
					</div>
				)}
			</div>
		</Layout.Header>
	) : (
		<Fragment />
	);
};

export default AppHeader;
